import { render, staticRenderFns } from "./_responsive-image.vue?vue&type=template&id=6b74a8f2"
import script from "./_responsive-image.vue?vue&type=script&lang=js"
export * from "./_responsive-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports